import profileEn from './profile/en.json';
import profileZhHant from './profile/zh-Hant.json';
import profileVi from './profile/vi.json';
import profileTh from './profile/th.json';

export default {
  en: profileEn,
  'zh-Hant': profileZhHant,
  vi: profileVi,
  th: profileTh,
};
